import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as analytics from 'analytics/Analytics';
import ContinueButton from 'nav/full-screen/ContinueButton';

import * as NewUserFlowActions from './NewUserFlowActions';
import {LAB_NOTEBOOK_FLOW, MOL_BIO_INFO_SCREEN} from './NewUserFlowConstants';

const ProductIllustration = ({fileName}) => (
  <center>
    <img src={`/static/img/enterprise/${fileName}`} className="callToActionScreen-productDescription-img" />
  </center>
);

ProductIllustration.propTypes = {
  fileName: PropTypes.string.isRequired,
};

const ProductOverview = ({
  name,
  tagline,
  featureList,
  illustrationFile,
  ctaText,
  ctaFunc,
  highlighted,
  primary,
}) => (
  <div
    className={classNames('callToActionScreen-productDescription', {
      'callToActionScreen-productDescription--highlighted': highlighted,
    })}
  >
    <h2>{name}</h2>
    <ProductIllustration fileName={illustrationFile} />
    <div className="callToActionScreen-productFeatureListContainer">
      <h4>{tagline}</h4>
      <ul>
        {featureList.map((featureText, i) => (
          <li key={i}>{featureText}</li>
        ))}
      </ul>
    </div>
    <div className="callToAction-continueButtonContainer">
      <ContinueButton text={ctaText} onClick={ctaFunc} primary={primary} />
    </div>
  </div>
);

ProductOverview.propTypes = {
  ctaFunc: PropTypes.func.isRequired,
  ctaText: PropTypes.string.isRequired,
  featureList: PropTypes.arrayOf(PropTypes.string).isRequired,
  highlighted: PropTypes.bool,
  illustrationFile: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  primary: PropTypes.bool,
  tagline: PropTypes.string.isRequired,
};

const openLabNotebook = () => {
  NewUserFlowActions.beginFlow(LAB_NOTEBOOK_FLOW);

  analytics.track('onboarding', 'clicked_cta_modal', {
    choice: 'clicked_open_new_entry',
  });
  analytics.track('new_user_flow', 'began_notebook_flow');
  analytics.track('onboarding_page', 'clicked', {
    page: 'choose_cta',
    objectClicked: 'button',
    objectText: 'Take Notes',
    eventLastModified: 'FY21_Q1a2',
  });
};

const openPlasmidEditor = () => {
  analytics.track('onboarding', 'clicked_cta_modal', {
    choice: 'plasmid_and_crispr',
  });
  analytics.track('onboarding_page', 'clicked', {
    page: 'choose_cta',
    objectClicked: 'button',
    objectText: 'Start Cloning',
    eventLastModified: 'FY21_Q1a2',
  });

  NewUserFlowActions.showScreen(MOL_BIO_INFO_SCREEN);
};

const PlasmidEditorProduct = () => (
  <ProductOverview
    name="Molecular Bio & CRISPR"
    illustrationFile="bioregistry.png"
    tagline="10+ biology tools, one interface."
    featureList={[
      'Design primers, align DNA, and more',
      'Design CRISPR gRNAs in seconds',
      'Import from SnapGene, Geneious, etc',
    ]}
    ctaText="Start Cloning"
    ctaFunc={openPlasmidEditor}
  />
);

const LabNotebookProduct = () => (
  <ProductOverview
    name="Lab Notebook"
    illustrationFile="lab-notebook.png"
    tagline="A notebook built for researchers."
    featureList={['Plan multi-day experiments', 'Easily reference all data', 'Get PDF exports, fast']}
    ctaText="Take Notes"
    ctaFunc={openLabNotebook}
    highlighted={true}
    primary={true}
  />
);

const CallToActionScreen = () => (
  <div className="callToActionScreen">
    <div className="callToActionScreen-welcome">
      <h1>Welcome to Benchling</h1>
      <p>
        Benchling is an intelligent research platform with tools for note-taking, molecular biology and
        CRISPR.
      </p>
    </div>
    <div className="callToActionScreen-productDescriptionContainer">
      <LabNotebookProduct />
      <PlasmidEditorProduct />
    </div>
  </div>
);

export default CallToActionScreen;
